import { useTranslation } from 'react-i18next'
import * as S from './AddProductRow.styles'

type AddProductRowProps = {
  onClick: () => void
}

function AddProductRow({ onClick }: AddProductRowProps) {
  const { t } = useTranslation()

  return (
    <S.Row>
      <S.AddProductButton onClick={onClick} data-testid="cart-add-product-row">
        <S.Plus />
        {t('order.add_product')}
      </S.AddProductButton>
    </S.Row>
  )
}

export default AddProductRow
